// Import the RTK Query methods from the React-specific entry point
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  encryptedStorage,
  EncryptedStorageKeys,
} from '@setup/encryptedStorage/encryptedStorage';
import { ApiBaseUrl } from '@utils/environmentVariables/environmentVariables';

export const apiSlice = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: ApiBaseUrl,
    prepareHeaders: (headers) => {
      const token = encryptedStorage.getItem(EncryptedStorageKeys.AccessToken);
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: [
    'User',
    'investment_intent',
    'marketing_preferences',
    'completed_questionnaire',
    'company_details',
    'ubo',
    'company_signatories',
    'nominee_agents',
    'nominee_customers',
    'nominee_investment_attributions'
  ],
  endpoints: () => ({}),
});
